import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OrganizationVerification from './OrganizationVerification';

const OrganizationVerificationPopup = ({ open, onClose, formData, initialData, lenderId, userId, preventClose }) => {
  
  const handleVerificationSuccess = () => {
    // Close the popup when verification is successful
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 200); // Add delay to ensure parent components have time to update
  };

  return (
    <Dialog 
      open={open} 
      onClose={preventClose ? undefined : onClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown={preventClose}
    >
      <Box sx={{ position: 'relative' }}>
        {!preventClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <DialogContent>
          <OrganizationVerification 
            formData={formData}
            initialData={initialData}
            onBack={onClose}
            lenderId={lenderId}
            userId={userId}
            preventClose={preventClose}
            onVerificationSuccess={handleVerificationSuccess}
          />
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default OrganizationVerificationPopup; 